const modulesConfig = {
  nh: {
    footer: {
      simplified: false,
      pageId: {
        dev: '292535',
        qa: '292535',
        uat: '292535',
        preview: '292535',
        prod: '292535'
      }
    },
    header: {
      simplified: false,
      pageId: {
        dev: '385178',
        qa: '385178',
        uat: '385178',
        preview: '385178',
        prod: '385178'
      }
    },
    faqsCategory: {
      dev: '19624',
      qa: '19624',
      uat: '19624',
      preview: '19624',
      prod: '19624'
    },
    form: {
      nationalitiesCategory: {
        dev: '19925',
        qa: '19925',
        uat: '19925',
        preview: '19925',
        prod: '19925'
      },
      countriesCategory: {
        dev: '249',
        qa: '249',
        uat: '249',
        preview: '249',
        prod: '249'
      },
      languagesCategory: {
        dev: '21590',
        qa: '21590',
        uat: '21590',
        preview: '21590',
        prod: '21590'
      },
      streetTypeCategory: {
        dev: '25235',
        qa: '25235',
        uat: '25235',
        preview: '25235',
        prod: '25235'
      }
    },
    preferences: {
      smokingRoom: {
        dev: '212898',
        qa: '212898',
        uat: '212898',
        preview: '212898',
        prod: '212898'
      },
      typeOfBed: {
        dev: '212899',
        qa: '212899',
        uat: '212899',
        preview: '212899',
        prod: '212899'
      },
      bathroom: {
        dev: '212895',
        qa: '212895',
        uat: '212895',
        preview: '212895',
        prod: '212895'
      },
      roomOrientation: {
        dev: '212897',
        qa: '212897',
        uat: '212897',
        preview: '212897',
        prod: '212897'
      },
      floorLevel: {
        dev: '212896',
        qa: '212896',
        uat: '212896',
        preview: '212896',
        prod: '212896'
      },
      welcomeDetail: {
        dev: '216659',
        qa: '216659',
        uat: '216659',
        preview: '216659',
        prod: '216659'
      },
      additionalRequirements: {
        dev: '216658',
        qa: '216658',
        uat: '216658',
        preview: '216658',
        prod: '216658'
      },
      liftProximity: {
        dev: '216656',
        qa: '216656',
        uat: '216656',
        preview: '216656',
        prod: '216656'
      }
    },
    interests: {
      destinations: {
        dev: '212901',
        qa: '212901',
        uat: '212901',
        preview: '212901',
        prod: '212901'
      },
      activities: {
        dev: '212900',
        qa: '212900',
        uat: '212900',
        preview: '212900',
        prod: '212900'
      }
    },
    filterSearchForm: {
      status: {
        dev: '214821',
        qa: '214821',
        uat: '214821',
        preview: '214821',
        prod: '214821'
      },
      activityType: {
        dev: '214820',
        qa: '214820',
        uat: '214820',
        preview: '214820',
        prod: '214820'
      }
    },
    liveLocalCategory: {
      dev: '212320',
      qa: '212320',
      uat: '212320',
      preview: '212320',
      prod: '212320'
    }
  }
}

export default modulesConfig
